import gql from 'graphql-tag';

export const createCoverageHours = gql`
  mutation createCoverageHours($input: InputCreateCoverageHours!) {
    createCoverageHours(input: $input) {
      id
      routingId
      teamId
      dayOfWeek
      startMinute
      endMinute
      timezone
    }
  }
`;
